import {AttachmentFile} from '@hconnect/common/types'
import {useQuery} from '@tanstack/react-query'

import {fetchReadSalesForecastExcel, salesForecastQueryKeys} from '../backend'

export const useReadSalesForecastExcel = (file: AttachmentFile) => {
  return useQuery({
    queryKey: [salesForecastQueryKeys.readSalesForecastExcel, file.id],
    queryFn: () => fetchReadSalesForecastExcel(file),
    throwOnError: true
  })
}
